export function formatDate(requestDate: Date): string {
  const date = new Date(requestDate);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = String(date.getFullYear()).slice(-2);

  return `${day}/${month}/${year}`;
}

const monthNames = [
  'ינואר',
  'פברואר',
  'מרץ',
  'אפריל',
  'מאי',
  'יוני',
  'יולי',
  'אוגוסט',
  'ספטמבר',
  'אוקטובר',
  'נובמבר',
  'דצמבר',
];

class DateUtils {
  displayFormatDate(reqDate: Date): string {
    const date = new Date(reqDate);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = String(date.getFullYear()).slice(-2);

    return `${day}/${month}/${year}`;
  }

  formattedDateWithNoTime = (dateOfBirth: Date) =>
    `${dateOfBirth.getFullYear()}-${(dateOfBirth.getMonth() + 1).toString().padStart(2, '0')}-${dateOfBirth.getDate().toString().padStart(2, '0')}`;

  displayDateInText(date: Date): string {
    const day = date.getDate();
    const month = date.getMonth() + 1; // getMonth() returns 0-11
    const year = date.getFullYear() % 100; // Get last 2 digits of year
    const fullYear = date.getFullYear();
    const hebrewMonth = monthNames[date.getMonth()];

    return `${day} ב${hebrewMonth}, ${fullYear}`;
  }

  // Don't touch it !!!!
  // Super important this is the key to store/send/receive dates with no time
  storeFormatDate(date: Date): string {
    return date.toISOString().split('T')[0]; // Gets the date in YYYY-MM-DD format
  }

  isDatePass(date: Date): boolean {
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);

    return now > checkDate;
  }

  formatToTwoDigits = (num: number): string => {
    return num.toString().padStart(2, '0');
  };

  formatTimeFromDate = (date: Date) => {
    const validData = new Date(date);
    const hours = validData.getHours().toString().padStart(2, '0');
    const minutes = validData.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  formatTimeRange = (startDate: Date, totalMinutes: number): string => {
    // Function to format the time as two-digit strings (HH:MM)
    const formatToTwoDigits = (num: number): string =>
      num.toString().padStart(2, '0');

    // Get start time
    const startHours = formatToTwoDigits(startDate.getHours());
    const startMinutes = formatToTwoDigits(startDate.getMinutes());

    // Calculate end time by adding totalMinutes to the start time
    const endDate = new Date(startDate.getTime() + totalMinutes * 60000);
    const endHours = formatToTwoDigits(endDate.getHours());
    const endMinutes = formatToTwoDigits(endDate.getMinutes());

    // Return formatted time range string
    return `${startHours}:${startMinutes} - ${endHours}:${endMinutes}`;
  };

  formatTimeRangeBetweenDates = (startDate: Date, endDate: Date): string => {
    const validStartDate = new Date(startDate);
    const validEndDate = new Date(endDate);
    if (!validEndDate || !validStartDate) {
      return '';
    }
    return `${dateUtils.formatToTwoDigits(validStartDate.getHours())}:${dateUtils.formatToTwoDigits(validStartDate.getMinutes())} - ${dateUtils.formatToTwoDigits(validEndDate.getHours())}:${dateUtils.formatToTwoDigits(validEndDate.getMinutes())}`;
  };

  getDayDisplayText = (day: WeekDay) => {
    switch (day) {
      case WeekDay.Sunday:
        return { dayName: 'ראשון', symbolLetter: 'א' };

      case WeekDay.Monday:
        return { dayName: 'שני', symbolLetter: 'ב' };

      case WeekDay.Tuesday:
        return { dayName: 'שלישי', symbolLetter: 'ג' };

      case WeekDay.Wednesday:
        return { dayName: 'רביעי', symbolLetter: 'ד' };

      case WeekDay.Thursday:
        return { dayName: 'חמישי', symbolLetter: 'ה' };

      case WeekDay.Friday:
        return { dayName: 'שישי', symbolLetter: 'ו' };

      case WeekDay.Saturday:
        return { dayName: 'שבת', symbolLetter: 'ש' };
    }
  };

  getClosestDate(date: Date, targetDay: WeekDay): Date {
    const currentDay = date.getDay();
    let diff = targetDay - currentDay;

    if (diff <= 0) {
      diff += 7;
    }

    const closestDate = new Date(date);
    closestDate.setDate(date.getDate() + diff);

    return closestDate;
  }

  addMinutesToDate(date: Date, minutes: number): Date {
    const newDate = new Date(date.getTime()); // Create a copy of the date
    newDate.setMinutes(newDate.getMinutes() + minutes); // Add the minutes
    return newDate;
  }

  getDisplayDateStr = (date: Date) => {
    const validDate = new Date(date);
    if (!validDate) {
      return '';
    }
    return `${validDate?.getDate()} ${validDate.toLocaleString('he-IL', { month: 'long' })}, שנת ${validDate?.getFullYear()}`;
  };

  calculateHoursDifference(startDate: Date, endDate: Date): number {
    const diffMs = new Date(endDate).getTime() - new Date(startDate).getTime();
    return diffMs / (1000 * 60 * 60);
  }

  getDeltaInMinutes(startDate: Date, endDate: Date): number {
    return Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60));
  }
}

const dateUtils = new DateUtils();
export default dateUtils;

export const enum WeekDay {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}
